// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"127":"4797b9ec","446":"fae524b6","449":"7170a4fb","801":"39aeb51e","995":"7170a4fb"}[chunkId] + ".chunk.css";
};